// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Which type of Modbus write operation to perform.
 */
export enum ModbusWriteType {
  WriteSingleRegister = 0,
  WriteSingleCoil = 1,
  WriteMultipleRegisters = 2,
  WriteMultipleCoils = 3,
  MaskWriteRegister = 4,
}
